import { CredencialesCertificacionService as service } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const CredencialesCertificacionManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const enviar = (data) => {
    return service
      .enviar({
        ...data,
        Files: data.Certificado ?? [],
      })
      .then((res) => {
        console.log(res);
        if (!res.Success) {
          console.log(res)
          handleException(res);
        }
        return res.Data;
      });
  };

  return {
    enviar,
  };
})();

